import React from 'react';

import { Circle } from './CategoryIcon.styled';

import { Props } from './CategoryIcon.types';

export const CategoryIcon = ({ size, icon }: Props) => <Circle size={size}>{icon}</Circle>;
